import { withStyles } from '@material-ui/core';

import EfsParkingPage from './component';
import styles from './styles';

export default withStyles(styles)(EfsParkingPage);
